const Index = resolve => require.ensure([], () => resolve(require('./Index.vue')), 'group-fund');

export default [{
  path: '/admin/research/projects/:projectId/funds',
  name: 'admin/research/projects/:projectId/funds',
  component: Index,
  meta: {
    title: '经费报销管理',
    layout: 'admin',
  },
}, {
  path: '/admin/research/funds',
  name: 'admin/research/funds',
  component: Index,
  meta: {
    title: '经费报销管理',
    layout: 'admin',
  },
}];




// WEBPACK FOOTER //
// ./src/pages/admin/research/funds/index.js